import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const radioDefaultVariants = {}
const radioCompoundVariants = [
  {
    "selected": true,
    "disabled": true,
    "css": {
      "control": {
        "borderColor": "border.disabled"
      },
      "indicator": {
        "background": "content.disabled"
      }
    }
  }
]

const radioSlotNames = [
  [
    "root",
    "Radio__root"
  ],
  [
    "control",
    "Radio__control"
  ],
  [
    "indicator",
    "Radio__indicator"
  ]
]
const radioSlotFns = /* @__PURE__ */ radioSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, radioDefaultVariants, getSlotCompoundVariant(radioCompoundVariants, slotName))])

const radioFn = memo((props = {}) => {
  return Object.fromEntries(radioSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const radioVariantKeys = [
  "error",
  "focusVisible",
  "selected",
  "disabled"
]
const getVariantProps = (variants) => ({ ...radioDefaultVariants, ...compact(variants) })

export const radio = /* @__PURE__ */ Object.assign(radioFn, {
  __recipe__: false,
  __name__: 'radio',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: radioVariantKeys,
  variantMap: {
  "error": [
    "true"
  ],
  "focusVisible": [
    "true"
  ],
  "selected": [
    "true"
  ],
  "disabled": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, radioVariantKeys)
  },
  getVariantProps
})